import { render } from "./SettingForm.vue?vue&type=template&id=343af464&scoped=true"
import script from "./SettingForm.vue?vue&type=script&lang=js"
export * from "./SettingForm.vue?vue&type=script&lang=js"

import "./SettingForm.vue?vue&type=style&index=0&id=343af464&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-343af464"

export default script